<script>
import Container from "%/dynamic-component-editor/standard-elements/layouts/Container.vue";
import CheckoutMode from "%/dynamic-component-editor/options/checkout-mode";
import LayoutPositionOptions from "%/dynamic-component-editor/bundles/layout-position-options";
import SpacingOptions from "%/dynamic-component-editor/bundles/spacing-options";
import AppearanceOptions from "%/dynamic-component-editor/bundles/appearance-options";
import BackgroundOptions from "%/dynamic-component-editor/bundles/background-options";
import { PlanSheetScopeMixin } from "%/dynamic-component-editor/standard-components/plan-sheet/plan-sheet-scope-mixin";
import {
  SHEET_CANVAS_HINT,
  SUBSCRIPTION_PLAN_CONTEXT,
} from "%/dynamic-component-editor/standard-components/plan-sheet/plan-sheet-state";

// The page's checkout overlay: a plan card's Subscribe opens it on mobile; members never see it inline.
// Designed inline on the canvas.
export default {
  name: "SubscriptionPlanSheet",
  extends: Container,
  mixins: [PlanSheetScopeMixin],
  elementPanelSettings: {
    alias: "Subscription Plan Sheet",
    displayName: "Subscription Plan Sheet",
    displayIcon: "layout",
    tags: ["container", "paywall", "plans", "subscription", "checkout", "sheet"],
  },
  // Its children read the selected plan, so they need no page-level plan context.
  providesSubtreeContext: SUBSCRIPTION_PLAN_CONTEXT,
  options: [
    CheckoutMode,
  ],
  optionBundles: [
    new LayoutPositionOptions({
      "default.static-layout-direction": "vertical",
    }),
    new AppearanceOptions({}, {
      "border-radius": false,
    }),
    SpacingOptions,
    BackgroundOptions,
  ],
  computed: {
    canvasHint() {
      return SHEET_CANVAS_HINT;
    },
  },
};
</script>
